import React, { useCallback } from 'react'
import { actionCreators as tasksActions } from '@/store/myActiveTask'
import LoadingIndicator from '@/components/LoadingIndicator'
import { useDispatch } from '@/hooks/dispatch'
import { useInitializer } from '@/hooks/useInitializer'
import { useReduxState } from '@/hooks/reduxState'

export function Initializer ({ children }) {
  const [getMyActiveTask] = useDispatch([tasksActions.getMyActiveTask])
  const { isAnonymousPath } = useInitializer({
    onLoad: useCallback(() => {
      getMyActiveTask()
    }, [getMyActiveTask])
  })
  const appReady = useReduxState(useCallback(state => state.myActiveTask.fetched, []))

  // render anonymous pages without waiting
  if (isAnonymousPath) {
    return children
  }

  // we don't want to render content until all the essential data is loaded
  if (!appReady) {
    return <LoadingIndicator />
  }

  // when access token expires or user is signed out during the work,
  // we want to keep user in app, just block it until new access token is available
  return children
}

export default Initializer



// WEBPACK FOOTER //
// ./src/internal-app/initializer.js